import moment from 'moment';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import OrderController, {
  KnockOrderItemType,
  OrderProductType,
  OrderStatusType,
} from '../../controller/OrderController';
import { CurrentStoreContext } from '../../controller/StoreController';
import { AuthContext } from '../../navigation/AuthProvider';
import {
  ORDER_CANCLE_STATUS,
  ORDER_COM_DEL_STATUS,
  ORDER_COM_STATUS,
  ORDER_READY_STATUS,
  ORDER_WAIT_STATUS,
} from '../../utils/DataType';
import RejectModal from '../../components/modal/RejectModal';
import RejectConfirmModal from '../../components/modal/RejectConfirmModal';
import SaleDetailModal from '../../components/modal/SaleDetailModal';
import { useToast } from '../../controller/ToastController';
import { getStoreTypeStatus } from './StatusComment';

type OrderProps = {
  order: KnockOrderItemType;
  isMobile: boolean;
  refreshAllOrder: any;
};

const SalesItem = (props: OrderProps) => {
  const showToast = useToast();

  const { userInfo } = useContext(AuthContext);

  const { currentStore } = useOutletContext<CurrentStoreContext>();

  const [isBlink, setIsBlink] = useState<boolean>(false);
  const [blinkCount, setBlinkCount] = useState<number>(
    currentStore.value &&
      currentStore.value.auto_confirmed === 1 &&
      props.order.child.order_status === ORDER_READY_STATUS
      ? 3
      : 0,
  );

  const [type, setType] = useState<string>('가게 사정');

  const [visibleReject, setVisibleReject] = useState<boolean>(false);
  const [visibleRejectConfirm, setVisibleRejectConfirm] = useState<boolean>(false);
  const [visibleDetail, setVisibleDetail] = useState<boolean>(false);

  const getTotalQuantity = () => {
    let totalQuantity = 0;
    props.order.child.detail.map((item: OrderProductType) => {
      totalQuantity += item.product_quantity;
    });
    return totalQuantity;
  };
  const getMenuListString = () => {
    let menuString = '';
    props.order.child.detail.map((item: OrderProductType) => {
      menuString += `${item.product_name} ${item.product_quantity}개 /`;
    });
    menuString = menuString.slice(0, -1);
    return menuString;
  };

  let interval: NodeJS.Timeout;

  const stopBlink = (interval: any) => {
    clearInterval(interval);
    setIsBlink(false);
  };

  const updateStatus = async () => {
    if (checkProgress()) {
      const oParams: OrderStatusType = {
        order_id: props.order.order_id,
        order_seq: props.order.child.order_seq,
        order_status: props.order.child.next_order_status,
        // props.child.next_order_status === -1
        //   ? 0
        //   : props.child.next_order_status, // test
        delivery_estimated_time: props.order.child.delivery_estimated_time,
        table_area_nr: props.order.table_area_nr,
        table_nr: props.order.table_nr,
        store_id: props.order.store_id,
        parent_store_id: props.order.parent_store_id,
        user_token_id: userInfo.user_token_id,
        status_changed_at: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      };

      //return;
      // console.log("oParams", oParams);
      const oRes = await OrderController.updateStatus(oParams);

      if (oRes && oRes.data) {
        console.log(
          'props.child.order_status',
          props.order.order_id,
          props.order.child.order_status,
        );
        // setRecoil(checkOrderState, new Date().getTime().toString());
        if (props.order.child.order_status === ORDER_COM_DEL_STATUS) {
          // setRecoil(completeOrderState, {
          //   date: new Date().getTime().toString(),
          //   order_status: props.child.next_order_status,
          // });
          setBlinkCount(0);
          // setRecoil(deliveryState, new Date().getTime().toString());
        } else {
          setBlinkCount(3);
        }

        showToast(
          getStoreTypeStatus(props.order.child.order_category, props.order.child.order_status)
            .toast,
          undefined,
          1500,
        );

        props.refreshAllOrder(1);
        // SoundControl.playSoundOnce();
        console.log('oRes', oRes);
      }
    }
  };

  // orderStatus API
  const cancelStatus = async () => {
    const oParams: OrderStatusType = {
      order_id: props.order.order_id,
      order_seq: props.order.child.order_seq,
      order_status: 4,
      table_area_nr: props.order.table_area_nr,
      table_nr: props.order.table_nr,
      store_id: props.order.store_id,
      parent_store_id: props.order.parent_store_id,
      cancel_description: type,
      user_token_id: userInfo.user_token_id,
      status_changed_at: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
    };

    //return;
    console.log('oParams', oParams);
    const oRes = await OrderController.updateStatus(oParams);

    if (oRes && oRes.data) {
      setVisibleDetail(false);
      setVisibleRejectConfirm(false);
    }
  };

  const isDisabledStatusButton = () => {
    if (props.order.child.delivery_type === 1) {
      if (
        props.order.child.order_status === ORDER_COM_DEL_STATUS ||
        props.order.child.order_status === ORDER_COM_STATUS
      )
        return true;
      else return false;
    } else {
      return false;
    }
  };

  const checkProgress = () => {
    return (
      props.order.child.order_status !== ORDER_CANCLE_STATUS &&
      props.order.child.order_status !== ORDER_COM_DEL_STATUS &&
      props.order.child.order_status !== ORDER_COM_STATUS
    );
  };

  const checkReject = () => {
    setVisibleReject(false);
    setVisibleRejectConfirm(true);
  };

  // 깜빡이
  useEffect(() => {
    const startBlink = () => {
      console.log('start blink');
      interval = setInterval(() => {
        setIsBlink((prevState) => !prevState);
      }, 600);
    };

    if (blinkCount === 0 && props.order.child.order_status !== ORDER_WAIT_STATUS) {
      stopBlink(interval!);
    } else {
      startBlink();
    }

    return () => stopBlink(interval);
  }, [props.order.child.order_status]);

  useEffect(() => {
    if (isBlink && blinkCount > 0) {
      setBlinkCount(blinkCount - 1);
      // console.log("~~~~~~~~~~~~~~~blink~~~~~~~~~~~~~~~~", isBlink, blinkCount);
    }
    if (blinkCount === 0 && props.order.child.order_status !== ORDER_WAIT_STATUS)
      stopBlink(interval);
  }, [isBlink]);

  const RenderOrderInfo = useMemo(() => {
    return (
      <div
        className="orderList"
        onClick={() => {
          if (props.isMobile) setVisibleDetail(true);
        }}>
        <div className="listWrap">
          {/* 주문타입 및 시간 */}
          <div className="listItem">
            <h4>{moment(new Date(props.order.child.ordered_at)).format('HH:mm')}</h4>
            <p>{moment(new Date(props.order.child.ordered_at)).format('YYYY-MM-DD')}</p>

            {!props.isMobile && (
              <h3 className="roomName">{props.order.child.delivery_address_detail}</h3>
            )}
          </div>

          {/* 주문정보 */}
          {props.isMobile ? (
            <div className="listItem center">
              <h3 className="prdName">{getMenuListString()}</h3>
              <div className="between">
                <h3>{props.order.store_name}</h3>
                <h3>|</h3>
                <h3>
                  {(
                    props.order.child.total_amount_incl - props.order.child.room_tip
                  ).toLocaleString()}
                  원
                </h3>
              </div>
            </div>
          ) : (
            <div className="listItem center">
              <div className="between">
                <h3>{props.order.child.hotel_name}</h3>
                <h3>
                  {(
                    props.order.child.total_amount_incl - props.order.child.room_tip
                  ).toLocaleString()}
                  원
                </h3>
              </div>
              <div className="menuWrap">
                {props.order.child.detail.map((item, index) => (
                  <>
                    <div key={index} className="between">
                      <h3 className="prdName">{item.product_name}</h3>
                      <h3 className="prdQuantity">{item.product_quantity}</h3>
                      <h3 className="prdPrice">{item.product_total_amount.toLocaleString()}원</h3>
                    </div>
                    {item.set_prd_type_list.map((set, setIndex: number) => {
                      return (
                        <>
                          <div className="between" key={setIndex}>
                            <img
                              src={`${process.env.PUBLIC_URL}/svg/ic_linebreak_black.svg`}
                              alt="img"
                            />
                          </div>
                          {set.set_product.map((setPrd, setPrdIndex: number) => {
                            const getOptionName = () => {
                              const optionNames = setPrd.options.map(
                                (option) => option.option_name,
                              );
                              return optionNames.join(', ');
                            };
                            return (
                              <div key={setPrdIndex}>
                                <h4>[세트] {setPrd.product_name}</h4>
                                <div className="row option">
                                  <h5>{getOptionName()}</h5>
                                </div>
                              </div>
                            );
                          })}
                        </>
                      );
                    })}
                    {item.options.map((option, optionIndex: number) => (
                      <div className="between" key={optionIndex}>
                        <img
                          src={`${process.env.PUBLIC_URL}/svg/ic_linebreak_black.svg`}
                          alt="img"
                        />
                        <h4>[옵션] {option.option_name}</h4>
                        <h4>{option.option_price.toLocaleString()}원</h4>
                      </div>
                    ))}
                  </>
                ))}
              </div>
            </div>
          )}

          {/* status변경 버튼 */}
          {!props.isMobile && (
            <div className="row gap">
              <button className="detailButton" onClick={() => setVisibleDetail(true)}>
                <p>상세</p>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_arrow_right.svg`} alt="img" />
              </button>
              {/* 주문정보 버튼 */}
              <button
                className={`stateButton cancelButton`}
                disabled={props.order.child.order_status === ORDER_CANCLE_STATUS}>
                <div className="buttonComment" onClick={() => setVisibleReject(true)}>
                  <h3>{'주문\n취소'}</h3>
                </div>
              </button>
              <button
                className={`stateButton
                ${props.order.child.order_status === ORDER_CANCLE_STATUS && 'cancel'}
        ${isDisabledStatusButton() && 'disabled'}  ${isBlink && 'notCheck'} `}>
                <div className="buttonComment" onClick={updateStatus}>
                  <h3>
                    {
                      getStoreTypeStatus(
                        props.order.child.order_category,
                        props.order.child.order_status,
                      ).button
                    }
                  </h3>
                  {props.order.child.order_status === ORDER_COM_DEL_STATUS ? (
                    <>
                      <h4 className="time">
                        {moment(new Date(props.order.child.delivery_completed_at!)).format('HH:mm')}
                      </h4>
                      <p className="time">
                        {moment(new Date(props.order.child.delivery_completed_at!)).format(
                          'YYYY-MM-DD',
                        )}
                      </p>
                    </>
                  ) : (
                    props.order.child.order_status === ORDER_COM_STATUS && (
                      <>
                        <h4 className="time">
                          {moment(new Date(props.order.child.completed_at!)).format('HH:mm')}
                        </h4>
                        <p className="time">
                          {moment(new Date(props.order.child.completed_at!)).format('YYYY-MM-DD')}
                        </p>
                      </>
                    )
                  )}
                </div>
              </button>
            </div>
          )}
        </div>
        {props.isMobile && (
          <div className="stateWrap">
            <button
              className={`stateButton
                ${props.order.child.order_status === ORDER_CANCLE_STATUS && 'cancel'}
        ${isDisabledStatusButton() && 'disabled'} ${isBlink && 'notCheck'} `}>
              <div className="buttonComment" onClick={() => setVisibleDetail(true)}>
                <h3>
                  {
                    getStoreTypeStatus(
                      props.order.child.order_category,
                      props.order.child.order_status,
                    ).button
                  }
                </h3>
              </div>
            </button>
          </div>
        )}
      </div>
    );
  }, [props, isBlink]);

  return (
    <>
      <Style>
        <div className="orderListWrap">{RenderOrderInfo}</div>
      </Style>
      <RejectModal
        isVisible={visibleReject}
        setVisible={setVisibleReject}
        setVisibleConfirm={checkReject}
        type={type}
        setType={setType}
        orderCategory={props.order.child.order_category}
      />
      <RejectConfirmModal
        isVisible={visibleRejectConfirm}
        setVisible={setVisibleRejectConfirm}
        onConfirm={cancelStatus}
      />
      <SaleDetailModal
        isVisible={visibleDetail}
        setVisible={setVisibleDetail}
        order={props.order}
        isMobile={props.isMobile}
        updateStatus={updateStatus}
        cancelStatus={cancelStatus}
        setVisibleReject={setVisibleReject}
        checkProgress={checkProgress}
      />
    </>
  );
};

export default SalesItem;

const Style = styled.div`
  .orderList {
    display: flex;
    padding: 32px 0;
    margin: 0 8%;
    justify-content: space-between;
    gap: 30px;
    border-bottom: 1px solid #e5e5e5;

    .listWrap {
      width: 100%;
      display: flex;
      gap: 30px;
    }
  }

  .listItem {
    min-height: 110px;

    h3 {
      font-size: 18px;
      color: #979797;
    }
    h4 {
      font-size: 16px;
      color: #979797;
    }
    p {
      padding-bottom: 16px;
      color: #979797;
    }

    h3.roomName {
      color: #555555;
    }
  }
  .listItem.center {
    flex: 1;
    .between {
      position: relative;
      display: flex;
      justify-content: space-between;
    }

    img {
      position: absolute;
      top: 4px;
      left: -18px;
    }

    h4 {
      font-size: 16px;
      line-height: 24px;
      color: #555555;
    }

    .menuWrap {
      padding-top: 26px;
      h3 {
        line-height: 28px;
        color: #555555;
      }

      h3.prdName {
        width: 160px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      h3.prdQuantity {
        width: 30px;
        text-align: center;
      }
      h3.prdPrice {
        width: 110px;
        text-align: right;
      }
    }
  }

  .row.gap {
    gap: 8px;
    align-items: flex-start;
  }

  .detailButton {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px 5px 14px;
    border: 1px solid #cecece;
    border-radius: 50px;

    p {
      font-size: 12px;
      line-height: 14px;
      color: #999999;
    }
    img {
      height: 14px;
    }
  }

  .stateButton {
    position: relative;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 90px;
    height: 110px;
    outline: none;
    /* box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.25); */
    background: #4dd2ae;
    border: 1px solid #4dd2ae;
    cursor: pointer;
    h3 {
      font-size: 18px;
      line-height: 22px;
      color: #ffffff;
      font-weight: 600;
    }

    .buttonComment {
      margin: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      white-space: pre-line;
      position: relative;

      h4 {
        line-height: 50px;
        color: #ffffff;
      }
      h4.cancel {
        position: absolute;
        top: 100px;
        font-size: 14px;
        line-height: 18px;
        color: #ff3542;
      }
      p {
        font-size: 10px;
        color: #fff;
        font-weight: 600;
      }
    }
  }

  .stateButton.notCheck {
    background: #ffffff;
    h3 {
      color: #4dd2ae;
    }
  }
  .stateButton.disabled {
    cursor: default;
    background: #cecece;
    border: 1px solid #cecece;
    .buttonComment {
      justify-content: space-evenly;
    }
    h3 {
      color: #ffffff;
      padding: 12px 0 6px 0;
    }
    h4.time {
      line-height: 20px;
    }
    p.time {
      line-height: 14px;
    }
  }
  .stateButton.disabled.notCheck {
    background: #f0f0f0;
    h3 {
      color: #b2b2b2;
    }
  }
  .stateButton.cancelButton {
    width: 60px;
    background: #ffffff;
    h3 {
      color: #4dd2ae;
    }
  }
  .stateButton.cancel {
    cursor: default;
    border: 1px solid #ffffff;
    background: #ff6060;
    h3 {
      color: #ffffff;
    }
  }

  @media (max-width: 900px) {
    .orderListWrap {
      padding: 0 10px;
    }
    .orderList {
      padding: 10px 14px;
      margin: 0;
      gap: 0;
      border: 1px solid #e5e5e5;
      border-radius: 10px;

      .listWrap {
        display: flex;
        flex-direction: column;
        gap: 0;
      }
      .stateWrap {
        display: flex;
        align-items: center;
        padding: 4px;
      }
    }

    .listItem {
      display: flex;
      min-height: auto;
      gap: 10px;
      h3 {
        font-size: 20px;
        line-height: 28px;
        font-weight: 600;
        color: #555555;
      }
      h4 {
        font-size: 14px;
        line-height: 18px;
        font-weight: 600;
        color: #555555;
      }
      p {
        font-size: 11px;
        padding-bottom: 0;
      }
      h3.roomName {
        color: #555555;
      }
    }
    .listItem.center {
      flex-direction: column;

      h3 {
        font-size: 14px;
        line-height: 18px;
        font-weight: 300;
        color: #979797;
      }

      .between {
        display: flex;
        justify-content: flex-start;
        gap: 8px;
      }

      img {
        position: absolute;
        top: 4px;
        left: -18px;
      }

      h4 {
        font-size: 16px;
        line-height: 24px;
        color: #555555;
      }

      h3.prdName {
        font-size: 18px;
        line-height: 28px;
        font-weight: 600;
        color: #555555;
        overflow: hidden;
        white-space: normal;
        /* text-overflow: ellipsis; */
      }
    }

    .stateButton {
      border-radius: 50px;
      width: 80px;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      h3 {
        font-size: 16px;
        line-height: 20px;
        color: #4dd2ae;
        font-weight: 600;
      }

      .buttonComment {
        white-space: nowrap;
        h4 {
          line-height: 50px;
          color: #ffffff;
        }
      }
    }
    .stateButton.disabled {
      background: #ffffff;
      h3 {
        padding: 0;
        color: #a7a7a7;
      }
    }
    .stateButton.notCheck {
      background: #4dd2ae;
      h3 {
        color: #ffffff;
      }
    }
    .stateButton.cancel {
      border: 1px solid #ff6060;
      background: #ffffff;
      h3 {
        color: #ff6060;
      }
    }
  }
`;
